import Skill2 from "../Components/Skill2";

export const Skills2 = () => {
  return (
    <section id="skills">
      <div className="skills">
        <h2>Skills</h2>
        <p>I have experience with these technologies</p>
        <div className="skillsGrid">
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
            alt="The logo icon for react"
            title="React"
          />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-plain.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original-wordmark.svg" />
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original-wordmark.svg"
            alt="The logo icon for HTML 5"
            title="HTML 5"
          />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-plain.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original-wordmark.svg" />
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg"
            alt="The logo icon for CSS3"
            title="CSS 3"
          />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg" />
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg"
            alt="The logo icon for TailwindCSS"
            title="Twilwind CSS"
          />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" />
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original-wordmark.svg"
            alt="The logo icon for GitHub"
            title="GitHub"
          />
          <Skill2
            source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg"
            alt="The logo icon for NodeJS"
            title="Node JS"
          />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/symfony/symfony-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-plain-wordmark.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" />
          <Skill2 source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" />
        </div>
      </div>
    </section>
  );
};
